module.exports = __webpack_public_path__ + "media/images/writer/logo-072daaffaa496cdb74e248ce544d6d87.png";